// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-features-in-viewport {
  position: absolute;
  bottom: 38px;
  left: 0;
  width: 100%;
  transition: left 0.5s ease-in-out;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box,
wm-features-in-viewport swiper-container swiper-slide wm-search-box {
  width: 100%;
  padding-left: 8px;
  margin: 0;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card {
  display: flex;
  width: 100%;
  height: 102px;
  margin: 0;
  padding: 8px;
  border-radius: 20px;
  gap: 16px;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card .wm-box-taxonomies,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card .wm-box-taxonomies {
  display: none;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card .wm-box-header-no-photo .wm-box-taxonomies,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card .wm-box-header-no-photo .wm-box-taxonomies {
  display: none;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card ion-card-header,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card ion-card-header {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-right: 0px;
  padding-left: 0px;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card ion-card-header ion-card-subtitle,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card ion-card-header ion-card-subtitle {
  padding: 0px;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card ion-card-header ion-card-title,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card ion-card-header ion-card-title {
  margin: 0px;
  padding: 0px;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card ion-card-header .wm-search-box-property.property-distance,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card ion-card-header .wm-search-box-property.property-distance {
  padding-left: 28px;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card ion-card-header .wm-search-box-property.property-distance::before,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card ion-card-header .wm-search-box-property.property-distance::before {
  content: var(--icon-distance-content, "\\e9a3");
  font-size: 23px;
  font-family: var(--wm-font-family, "webmapp");
  position: absolute;
  left: 0;
  top: 0;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card wm-img,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card wm-img {
  width: 118px;
  min-height: 86px !important;
}
wm-features-in-viewport wm-swiper swiper-slide wm-search-box ion-card wm-img img,
wm-features-in-viewport swiper-container swiper-slide wm-search-box ion-card wm-img img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
wm-features-in-viewport wm-swiper.slide-in,
wm-features-in-viewport swiper-container.slide-in {
  animation: slideIn 0.4s forwards;
}
wm-features-in-viewport wm-swiper.slide-out,
wm-features-in-viewport swiper-container.slide-out {
  animation: slideOut 0.4s forwards;
}
@keyframes slideIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slideOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
}

@media (min-width: 768px) {
  .details-container.details-container-visible ~ wm-geobox-map wm-features-in-viewport {
    left: 400px;
    width: calc(100% - 400px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/features-in-viewport/features-in-viewport.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,iCAAA;AACF;AAIM;;EACE,WAAA;EACA,iBAAA;EACA,SAAA;AADR;AAEQ;;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;AACV;AAAU;;EACE,aAAA;AAGZ;AAAY;;EACE,aAAA;AAGd;AAAU;;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;AAGZ;AAFY;;EACE,YAAA;AAKd;AAHY;;EACE,WAAA;EACA,YAAA;AAMd;AAJY;;EACE,kBAAA;AAOd;AALY;;EACE,8CAAA;EACA,eAAA;EACA,6CAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AAQd;AAJU;;EACE,YAAA;EACA,2BAAA;AAOZ;AALY;;EACE,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AAQd;AADI;;EACE,gCAAA;AAIN;AADI;;EACE,iCAAA;AAIN;AADI;EACE;IACE,2BAAA;IACA,UAAA;EAGN;EADI;IACE,wBAAA;IACA,UAAA;EAGN;AACF;AAAI;EACE;IACE,wBAAA;IACA,UAAA;EAEN;EAAI;IACE,2BAAA;IACA,UAAA;EAEN;AACF;;AAKA;EACE;IACE,WAAA;IACA,yBAAA;EAFF;AACF","sourcesContent":["wm-features-in-viewport {\n  position: absolute;\n  bottom: 38px;\n  left: 0;\n  width: 100%;\n  transition: left 0.5s ease-in-out;\n\n  wm-swiper,\n  swiper-container {\n    swiper-slide {\n      wm-search-box {\n        width: 100%;\n        padding-left: 8px;\n        margin: 0;\n        ion-card {\n          display: flex;\n          width: 100%;\n          height: 102px;\n          margin: 0;\n          padding: 8px;\n          border-radius: 20px;\n          gap: 16px;\n          .wm-box-taxonomies {\n            display: none;\n          }\n          .wm-box-header-no-photo {\n            .wm-box-taxonomies {\n              display: none;\n            }\n          }\n          ion-card-header{\n            display: flex;\n            flex-direction: column;\n            justify-content: space-evenly;\n            padding-right: 0px;\n            padding-left: 0px;\n            ion-card-subtitle{\n              padding: 0px;\n            }\n            ion-card-title{\n              margin: 0px;\n              padding: 0px;\n            }\n            .wm-search-box-property.property-distance {\n              padding-left: 28px;\n            }\n            .wm-search-box-property.property-distance::before {\n              content: var(--icon-distance-content,'\\e9a3');\n              font-size: 23px;\n              font-family: var(--wm-font-family,'webmapp');\n              position: absolute;\n              left: 0;\n              top: 0;\n            }\n          }\n\n          wm-img {\n            width: 118px;\n            min-height: 86px !important;\n\n            img {\n              -webkit-user-drag: none;\n              -khtml-user-drag: none;\n              -moz-user-drag: none;\n              -o-user-drag: none;\n              user-select: none;\n              -moz-user-select: none;\n              -webkit-user-select: none;\n              -ms-user-select: none;\n            }\n          }\n        }\n      }\n    }\n\n    &.slide-in {\n      animation: slideIn 0.4s forwards;\n    }\n\n    &.slide-out {\n      animation: slideOut 0.4s forwards;\n    }\n\n    @keyframes slideIn {\n      from {\n        transform: translateY(100%);\n        opacity: 0;\n      }\n      to {\n        transform: translateY(0);\n        opacity: 1;\n      }\n    }\n\n    @keyframes slideOut {\n      from {\n        transform: translateY(0);\n        opacity: 1;\n      }\n      to {\n        transform: translateY(100%);\n        opacity: 0;\n      }\n    }\n  }\n}\n\n// Quando details-container ha la classe details-container-visible,\n// wm-features-in-viewport si adatta per desktop\n@media (min-width: 768px) {\n  .details-container.details-container-visible ~ wm-geobox-map wm-features-in-viewport {\n    left: 400px;\n    width: calc(100% - 400px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
